import React from 'react';
import { object, func } from 'prop-types';
import { Button, HasPermissions } from '../../../../components/common';
import AuditOrderCardContent from './AuditOrderCardContent';

const AuditSingleOrderCard = ({ data, onOrderClick, bipickingInfo, style }) => {
    return (<div style={style}>
        <div style={{ width: '100%' }}>
            <AuditOrderCardContent
                data={data}
                onClickHandler={onOrderClick}
                bipickingInfo={bipickingInfo}
            />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <HasPermissions to={['audit-monitor:audit-action']}>
                    <Button
                        text='Auditar'
                        onClick={() => onOrderClick(data)}
                        style={{ width: '50%' }}
                        secondary
                    />
                </HasPermissions>
            </div>
        </div>
    </div>);
};

AuditSingleOrderCard.propTypes = {
    data: object.isRequired,
    onOrderClick: func.isRequired,
    bipickingInfo: object
};

export default AuditSingleOrderCard;